import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const G_FourRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            G_del_dis,
            G_joripara,
            dolartodinar,
            G_waslKrdn,
            G_total,
            G_totalID,
            G_paraDanID,
            G_paraDan$,
            dinartodolar,
            G_waslKrdnID,
            G_save,
            G_search_wasl,
            G_open,
            G_openUpdate,
            G_wasl,
            L_user,
            G_updateSale,
            G_loading,
            G_hideLoader,
            G_showLoader,
            G_onSaveRent,
            G_pageminsone,
            G_pageplusone
          } = value;
          return (
            <>
              <div className="row">
                <div className="col-sm-5 text-right mt-2">
                  <div className="form-group">
                    {G_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ کۆی گشتی
                        </label>
                        <NumberFormat
                          value={G_total}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          className="form-control text-center bg-white f5"
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID کۆی گشتی
                        </label>
                        <NumberFormat
                          value={G_totalID}
                          displayType={"text"}
                          className="form-control text-center bg-white f5"
                          thousandSeparator={true}
                          prefix={"ID"}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {G_joripara == "دینار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ کۆی گشتی
                        </label>
                        <NumberFormat
                          value={
                            G_paraDanID != 0 && G_paraDanID != ""
                              ? dinartodolar(G_waslKrdnID())
                              : dinartodolar(G_totalID)
                          }
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          className="form-control text-center bg-white f5"
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID کۆی گشتی
                        </label>
                        <NumberFormat
                          value={
                            G_paraDan$ != 0 && G_paraDan$ != ""
                              ? dolartodinar(G_waslKrdn())
                              : dolartodinar(G_total)
                          }
                          displayType={"text"}
                          className="form-control text-center bg-white f5"
                          thousandSeparator={true}
                          prefix={"ID"}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="col-2 text-right mt-5">
                  {G_search_wasl != null ? (
                    <>
                      {G_open == null ? (
                        <button
                          onClick={(e) =>
                            G_openUpdate(
                              G_wasl.numberOfWakil,
                              L_user._id,
                              e,
                              G_wasl._id
                            )
                          }
                          className="btn btn-warning "
                          style={{
                            backgroundColor: "silver",
                            border: "1px solid silver"
                          }}
                        >
                          <i className="fas fa-lock"></i>
                        </button>
                      ) : (
                        <button
                          onClick={(e) =>
                            G_updateSale(G_wasl.numberOfWakil, G_wasl._id, e)
                          }
                          className="btn btn-primary "
                          style={{ backgroundColor: "navy" }}
                        >
                          <i className="fas fa-edit "></i>
                        </button>
                      )}
                    </>
                  ) : G_save == true ? (
                    <>
                      {G_open == null ? (
                        <button
                          onClick={(e) =>
                            G_openUpdate(
                              G_wasl.numberOfWakil,
                              L_user._id,
                              e,
                              G_wasl._id
                            )
                          }
                          className="btn btn-warning "
                          style={{
                            backgroundColor: "silver",
                            border: "1px solid silver"
                          }}
                        >
                          <i className="fas fa-lock"></i>
                        </button>
                      ) : (
                        <button
                          onClick={(e) =>
                            G_updateSale(G_wasl.numberOfWakil, G_wasl._id, e)
                          }
                          className="btn btn-primary "
                          style={{ backgroundColor: "navy" }}
                        >
                          <i className="fas fa-edit "></i>
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {G_loading ? (
                        <button
                          type="button"
                          onDoubleClick={G_hideLoader}
                          className="btn btn-success "
                        >
                          <i clasName="fas fa-spinner animate__animated animate__rotateIn animate__infinite"></i>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={(e) => {
                            G_showLoader(e);
                            G_onSaveRent(e);
                          }}
                          className="btn btn-success"
                        >
                          <i className="far fa-save fa-lg"></i>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
              {/*seconnd row  */}
              <div className="row ">
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {G_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ پارەی دراو
                        </label>
                        <NumberFormat
                          displayType={"input"}
                          thousandSeparator={true}
                          disabled={G_del_dis == true ? true : null}
                          name="G_paraDan$"
                          onChange={AddProChange}
                          value={G_paraDan$}
                          style={{
                            padding: "8px 4px",
                            backgroundColor: `${
                              G_save == true || G_search_wasl == true
                                ? "white"
                                : ""
                            }`
                          }}
                          className={`f5 form-control text-right font-weight-bold text-center`}
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID پارەی دراو
                        </label>
                        <NumberFormat
                          disabled={G_del_dis == true ? true : null}
                          name="G_paraDanID"
                          onChange={AddProChange}
                          value={G_paraDanID}
                          style={{ padding: "8px 4px" }}
                          className={`f5 form-control text-right font-weight-bold text-center ${
                            G_save == true || G_search_wasl == true
                              ? "bg-white"
                              : ""
                          }`}
                          displayType={"input"}
                          thousandSeparator={true}
                        />
                      </>
                    )}
                  </div>
                </div>
                {/* paray pash dashkan */}
                <div className="col-5 text-right mt-4">
                  <div className="form-group ">
                    <button
                      className="btn btn-dark p3 px-4 mt-3"
                      disabled={G_open == true ? true : null}
                      onClick={G_pageminsone}
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                    >
                      <i className="fas fa-caret-left f4"></i>
                    </button>
                  </div>
                </div>
                <div className="col-2 text-right mt-4">
                  <div className="form-group">
                    <button
                      className="btn btn-dark p3 px-4 ml3 mt-3"
                      disabled={G_open == true ? true : null}
                      onClick={G_pageplusone}
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                    >
                      <i className="fas fa-caret-right f4"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/*Third row  */}
              <div className="row card-header p-1 border-bottom border-warning">
                {/* paray pash dashkan */}
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {G_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ پارەی نەدراو
                        </label>
                        {G_paraDan$ != 0 && G_paraDan$ != "" ? (
                          <>
                            <NumberFormat
                              value={G_waslKrdn()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={G_total}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID پارەی نەدراو
                        </label>
                        {G_paraDanID != 0 && G_paraDanID != "" ? (
                          <>
                            <NumberFormat
                              value={G_waslKrdnID()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={G_totalID}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="col-2 text-right mt-4"></div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default G_FourRow;
